module.exports = __webpack_public_path__ + "static/assets/bb29f572ce6bba004759e86733431bd9.png";